<script setup>
defineProps({
    items: {
        type: Array,
        default: () => []
    }
});

const userMenu = ref();
const toggleUserMenu = (event) => {
    userMenu.value.toggle(event);
};
</script>
<template>
    <div class="flex items-center">
        <div>
            <router-link
                to="/impressum"
                target="_blank"
                class="p-5 text-white hover:bg-white/32"
            >
                {{ $t('ux.labels.imprint') }}
            </router-link>
        </div>
        <div>
            <router-link
                to="/datenschutz"
                target="_blank"
                class="p-5 text-white hover:bg-white/32"
            >
                {{ $t('ux.labels.privacy') }}
            </router-link>
        </div>
        <Button
            class="mr-6 p-5 text-white hover:bg-white/32"
            text
            rounded
            size="large"
            severity="primary"
            icon="pi pi-user"
            aria-haspopup="true"
            aria-controls="user_menu"
            data-testid="user-menu-btn"
            @click="toggleUserMenu"
        />
        <Menu
            id="user_menu"
            ref="userMenu"
            class="text-sm"
            :model="items"
            :popup="true"
        >
            <template #submenulabel="{ item }">
                <span class="text-xs font-semibold uppercase">{{
                    item.label
                }}</span>
            </template>
        </Menu>
    </div>
</template>
